import { green, grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

const TAB_HEIGHT = "26px";

const FONT_SIZE = 12;

const TEXT_COLOR = "#232a31";

const inputDefaultProps = {
  size: "small",
  variant: "outlined",
};

// Handsome Homebuyer
// const SECONDARY_MAIN_COLOR = "#fef3c7"; // background of tabs
// const PRIMARY_MAIN_COLOR = "#062e6f"; // border on tab button

// Lendmarq Homebuyer
const SECONDARY_MAIN_COLOR = "#ebeff8"; // background of tabs
// const SECONDARY_MAIN_COLOR = "#e8edfa"; // background of tabs
const PRIMARY_MAIN_COLOR = "#2962ff"; // border on tab button

// Function to create theme based on the mode
const generateMuiThemeDefaults = ({}) => {
  return createTheme({
    palette: {
      mode: "light",
      primary: {
        // primary.main is the brand blue — used for active tab borders,
        // focused inputs, and primary buttons
        main: PRIMARY_MAIN_COLOR,
      },
      secondary: {
        // secondary.main is the accent yellow — used for active tab backgrounds,
        // highlights, and supplementary UI accents
        main: SECONDARY_MAIN_COLOR,
        // activeTabBg is the translucent form of secondary used specifically
        // for active tab/button background fills
        activeTabBg: SECONDARY_MAIN_COLOR, // secondary.main at ~75% opacity
        // activeTabBg: "rgba(254, 243, 199, 0.75)", // secondary.main at ~75% opacity
      },

      divider: "#dde1e7",
      dividerLight: "#e5e7eb",
      separator: "#dde0e4",
      background: {
        default: "#ffffff",
        secondary: "#fdfefe",
      },
      text: {
        primary: TEXT_COLOR,
        secondary: "rgba(0, 0, 0, 0.6)",
        title: "#062e6f",
      },
      success: {
        main: green[800],
      },
    },

    typography: {
      fontFamily: "var(--primaryFont)",
      fontSize: FONT_SIZE,
      h1: {
        fontFamily: `"Lora", serif`,
        fontSize: "1.35rem",
        fontWeight: 800,
      },
      h2: {
        fontSize: "1.125rem",
        fontFamily: "var(--primaryFont)",
        fontWeight: 600,
      },
      h3: {
        fontFamily: "var(--primaryFont)",
        fontSize: "15px",
        fontWeight: 500,
      },
      h4: {
        fontFamily: "var(--primaryFont)",
        fontSize: "0.875rem",
        fontWeight: 400,
      },
      h5: {
        fontSize: "0.75rem",
        fontWeight: 400,
      },
      h6: {
        fontSize: "0.625rem",
        fontWeight: 400,
      },
    },
    components: {
      MuiInputBase: {
        defaultProps: { ...inputDefaultProps },
      },

      MuiTooltip: {
        defaultProps: {
          placement: "top",
          arrow: true,
          disableInteractive: true,
        },
        styleOverrides: {
          tooltip: {
            fontSize: "12px",
            padding: "8px",
          },
        },
      },
      MuiInputAdornment: {
        styleOverrides: {
          root: {
            color: TEXT_COLOR,
            "& .MuiSvgIcon-root": {
              fontSize: "15px",
              color: TEXT_COLOR,
            },
            input: {
              "&::placeholder": {
                fontWeight: "400 !important",
              },
            },
          },
        },
      },

      MuiTextField: {
        defaultProps: { ...inputDefaultProps },
      },

      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: "11.5px",
            opacity: 0.85,
            fontStyle: "italic",
            marginLeft: "0px",
            "&.Mui-error": {
              marginLeft: "0px",
            },
          },
        },
      },

      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: "13px",
          },
        },
      },
      MuiCard: {
        variants: [
          {
            props: { suppressPadding: true },
            style: {
              padding: 0,
            },
          },
          {
            props: { variant: "outlined" },
            style: ({ theme }) => ({
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }),
          },
        ],
        styleOverrides: {
          root: ({ theme }) => ({
            background: theme.palette.background.default,
            padding: "14px",
            borderRadius: "8px",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            border: `1px solid #e1e4e869`,
            overflow: "hidden",
          }),
        },
      },

      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: TAB_HEIGHT,
          },
        },
      },

      MuiToggleButton: {
        styleOverrides: {
          root: {
            textTransform: "capitalize",
          },
        },
      },

      MuiButton: {
        variants: [
          {
            props: { size: "xs" },
            style: {
              padding: "2px 8px",
              minWidth: "30px",
            },
          },
          {
            props: { variant: "contained", color: "gray" },
            style: {
              backgroundColor: "#f2f2f2",
              "&:hover": {
                backgroundColor: "#cfcfcf",
              },
            },
          },
          {
            props: { variant: "outlined", color: "gray" },
            style: {
              borderColor: grey[500],
              color: grey[600],
              "&:hover": {
                borderColor: "#707070",
                backgroundColor: "rgba(158, 158, 158, 0.04)",
              },
            },
          },
          {
            props: { variant: "text", color: "gray" },
            style: {
              color: "#9e9e9e",
              "&:hover": {
                backgroundColor: "rgba(158, 158, 158, 0.04)",
              },
            },
          },
        ],
        defaultProps: {
          variant: "contained",
          color: "primary",
          size: "small",
        },
        styleOverrides: {
          root: {
            flexShrink: 0,
            fontWeight: 500,
            textTransform: "initial",
            boxShadow: "none",
          },
        },
      },
    },
  });
};

export default generateMuiThemeDefaults;

// import { green, grey } from "@mui/material/colors";
// import { createTheme } from "@mui/material/styles";

// const TAB_HEIGHT = "26px";

// const FONT_SIZE = 12;

// const TEXT_COLOR = "#232a31";

// const inputDefaultProps = {
//   size: "small",
//   variant: "outlined",
// };

// // Function to create theme based on the mode
// const generateMuiThemeDefaults = ({}) => {
//   return createTheme({
//     palette: {
//       mode: "light",
//       primary: {
//         main: "#062e6f",
//         // main: yellow[700]
//       },
//       secondary: {
//         main: "#fef3c7",
//         // main: "#fbca0b3b",
//         // main: "#062e6f",
//         // main: "#656e76",
//       },

//       divider: "#dde1e7",
//       // divider: "#bdc3c7",
//       dividerLight: "#e5e7eb",
//       separator: "#dde0e4",
//       // dividerLight: blueGrey[100],
//       background: {
//         default: "#ffffff",
//         secondary: "#fdfefe",
//       },
//       text: {
//         primary: TEXT_COLOR,
//         // primary: "rgba(0, 0, 0, 0.87)",
//         secondary: "rgba(0, 0, 0, 0.6)",
//         title: "#062e6f",
//       },
//       success: {
//         main: green[800],
//       },
//     },

//     typography: {
//       fontFamily: "var(--primaryFont)",
//       // fontFamily: `"Inter", serif;`,
//       fontSize: FONT_SIZE,
//       h1: {
//         // fontSize: "48px",
//         fontFamily: `"Lora", serif`,
//         fontSize: "1.35rem",
//         fontWeight: 800,
//       },
//       h2: {
//         // fontSize: "40px",
//         fontSize: "1.125rem",
//         // fontFamily: `"Lora", serif`,
//         fontFamily: "var(--primaryFont)",
//         fontWeight: 600,
//       },
//       h3: {
//         // fontSize: "32px",
//         fontFamily: "var(--primaryFont)",
//         // fontFamily: `"Lora", serif`,
//         // color: "#062e6f",
//         fontSize: "15px",
//         // fontSize: "1rem",
//         fontWeight: 500,
//       },
//       h4: {
//         // fontFamily: `"Lora", serif`,
//         fontFamily: "var(--primaryFont)",
//         fontSize: "0.875rem",

//         fontWeight: 400,
//       },
//       h5: {
//         fontSize: "0.75rem",
//         fontWeight: 400,
//       },
//       h6: {
//         fontSize: "0.625rem",
//         fontWeight: 400,
//       },
//     },
//     components: {
//       MuiInputBase: {
//         defaultProps: { ...inputDefaultProps },
//       },

//       // MuiTypography: {
//       //   styleOverrides: {
//       //     root: {
//       //       lineHeight: 1.5,
//       //     },
//       //   },
//       // },

//       MuiTooltip: {
//         defaultProps: {
//           placement: "top",
//           arrow: true,
//           disableInteractive: true,
//         },
//         styleOverrides: {
//           tooltip: {
//             fontSize: "12px",
//             padding: "8px",
//             // background: TEXT_COLOR
//           },
//         },
//       },
//       MuiInputAdornment: {
//         styleOverrides: {
//           root: {
//             color: TEXT_COLOR, // White adornment in dark mode
//             "& .MuiSvgIcon-root": {
//               fontSize: "15px",
//               // fontSize: '1.5rem',
//               color: TEXT_COLOR, // White adornment in dark mode
//               // color: '#1976d2',
//             },
//             input: {
//               "&::placeholder": {
//                 fontWeight: "400 !important",
//                 // You can also change color, font-size, etc. here
//               },
//             },
//           },
//         },
//       },

//       MuiTextField: {
//         defaultProps: { ...inputDefaultProps },
//       },

//       MuiFormHelperText: {
//         styleOverrides: {
//           root: {
//             fontSize: "11.5px",
//             opacity: 0.85,
//             fontStyle: "italic",
//             marginLeft: "0px",
//             "&.Mui-error": {
//               // styles you want specifically when error = true
//               // color: "red",           // or any color
//               marginLeft: "0px", // override any left margin if needed
//               // fontWeight: 600,        // example of another style
//             },
//           },
//         },
//       },

//       MuiFormLabel: {
//         styleOverrides: {
//           root: {
//             // fontSize: "12px",
//             fontSize: "13px",
//             // color: INPUT_LABEL_COLOR,
//           },
//         },
//       },
//       MuiCard: {
//         variants: [
//           // Existing custom variant
//           {
//             props: { suppressPadding: true },
//             style: {
//               padding: 0,
//             },
//           },
//           // New outline variant
//           {
//             props: { variant: "outlined" },
//             style: ({ theme }) => ({
//               // border: `1px solid ${grey[300]}`,
//               // boxShadow: "none",
//               boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//             }),
//           },
//         ],
//         styleOverrides: {
//           root: ({ theme }) => ({
//             background: theme.palette.background.default,
//             padding: "14px",
//             borderRadius: "8px",
//             // borderRadius: "4px",
//             // boxShadow: "var(--bs)",
//             // boxShadow: "rgb(0 0 0 / 10%) 0px 1px 2px",
//             boxShadow:
//               "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
//             border: `1px solid #e1e4e869`, // 1px solid #e5e7eb
//             overflow: "hidden",
//           }),
//         },
//       },
//       // MuiCard: {
//       //   variants: [
//       //     // Existing custom variant
//       //     {
//       //       props: { suppressPadding: true },
//       //       style: {
//       //         padding: 0,
//       //       },
//       //     },
//       //     // New outline variant
//       //     {
//       //       props: { variant: "outlined" },
//       //       style: ({ theme }) => ({
//       //         // border: `1px solid ${theme.palette.dividerLight}`,
//       //         border: `1px solid ${grey[300]}`,
//       //         // border: "1px solid #e1e4e8",
//       //         // boxShadow: "#7f8f9f4d 0px 4px 8px",
//       //         // boxShadow: "#7f8f9f4d 0px 4px 8px",
//       //         boxShadow: "none",
//       //       }),
//       //     },
//       //   ],
//       //   styleOverrides: {
//       //     root: ({ theme }) => ({
//       //       background: theme.palette.background.default,
//       //       padding: "14px",
//       //       borderRadius: "8px",
//       //       // borderRadius: "4px",
//       //       // boxShadow: "var(--bs)",
//       //       // boxShadow: "rgb(0 0 0 / 10%) 0px 1px 2px",
//       //       boxShadow:
//       //         "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
//       //       // boxShadow:
//       //       //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
//       //       // boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px;",
//       //       border: `1px solid #e1e4e869`, // 1px solid #e5e7eb
//       //       // border: `1px solid #e1e4e8`, // 1px solid #e5e7eb
//       //       // border: `1px solid ${theme.palette.dividerLight}`, // 1px solid #e5e7eb
//       //       overflow: "hidden",
//       //     }),
//       //   },
//       // },

//       MuiTabs: {
//         styleOverrides: {
//           root: {
//             minHeight: TAB_HEIGHT,
//           },
//         },
//       },

//       MuiToggleButton: {
//         styleOverrides: {
//           root: {
//             // padding: "2px 8px",
//             textTransform: "capitalize",
//           },
//         },
//       },

//       // MuiBackdrop: {
//       //   styleOverrides: {
//       //     root: {
//       //       // padding: "2px 8px",
//       //       backgroundColor: "rgba(71,85,105,.5)",
//       //       backdropFilter: "blur(4px)",
//       //     },
//       //   },
//       // },

//       MuiButton: {
//         variants: [
//           {
//             props: { size: "xs" },
//             style: {
//               padding: "2px 8px",
//               // padding: "4px 8px",
//               // fontSize: "12px",
//               minWidth: "30px",
//             },
//           },
//           {
//             props: { variant: "contained", color: "gray" },
//             style: {
//               backgroundColor: "#f2f2f2",
//               "&:hover": {
//                 backgroundColor: "#cfcfcf",
//               },
//             },
//           },
//           {
//             props: { variant: "outlined", color: "gray" },
//             style: {
//               borderColor: grey[500],
//               color: grey[600],
//               "&:hover": {
//                 borderColor: "#707070",
//                 backgroundColor: "rgba(158, 158, 158, 0.04)",
//               },
//             },
//           },
//           {
//             props: { variant: "text", color: "gray" },
//             style: {
//               color: "#9e9e9e",
//               "&:hover": {
//                 backgroundColor: "rgba(158, 158, 158, 0.04)",
//               },
//             },
//           },
//         ],
//         defaultProps: {
//           variant: "contained",
//           color: "primary",
//           size: "small",
//         },
//         styleOverrides: {
//           root: {
//             flexShrink: 0,
//             fontWeight: 500,
//             // fontWeight: 700,
//             textTransform: "initial",
//             boxShadow: "none",
//           },
//         },
//       },
//     },
//   });
// };

// export default generateMuiThemeDefaults;
